class ActiveCache {
	constructor() {
		this.$storage = localStorage;
	}

	/**
	 *
	 * @param key
	 * @param value
	 */
	cacheSet(key, value) {
		this.$storage.setItem(key, JSON.stringify(value));
	}

	/**
	 *
	 * @param key
	 */
	cacheGet(key) {
		return JSON.parse(this.$storage.getItem(key));
	}

	/**
	 *
	 * @param key
	 * @param subKey
	 * @param value
	 */
	cacheUpdate(key, subKey, value) {
		let data = this.cacheGet(key);
		data[subKey] = value;
		this.cacheSet(key, data);
	}

	/**
	 *
	 * @param key
	 */
	cacheRemove(key) {
		this.$storage.removeItem(key);
	}

	cacheClear() {
		this.$storage.clear();
	}
}

export default ActiveCache;



// WEBPACK FOOTER //
// ./rapid/cache.active.js